import React, { useState, useEffect } from 'react';
import { Calendar, dateFnsLocalizer, Views } from 'react-big-calendar';
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import { startOfWeek, eachDayOfInterval, endOfWeek } from 'date-fns';
import getDay from 'date-fns/getDay';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import './event-calendar.css';
import { getCookie } from '../../getcookie.js';
import axios from 'axios';
import { Container, Row, Col } from 'react-bootstrap';
import { FaFlag } from "react-icons/fa";
import { ReactComponent as TimeInfoIcon } from "../../../Assets/svg/time-info.svg";
import { ReactComponent as FlagICon } from "../../../Assets/svg/flag_ic.svg";
import { addMonths, subMonths, addWeeks, subWeeks, startOfMonth, endOfMonth } from "date-fns";
import prevIcon from "../../../Assets/svg/arrow-prev.svg";
import nextIcon from "../../../Assets/svg/arrow-next.svg";
import calendarIcon from "../../../Assets/svg/calendar.svg";
import moment from "moment";
import CalendarDateViewModal from '../modal/calendar-date-view.js';
const locales = {
  'en-US': require('date-fns/locale/en-US'),
};

const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
});

const TicketCalendar = ({ tableData = [], onChangeDateRange, listingType }) => {
  const [view, setView] = useState(Views.MONTH);
  const [events, setEvents] = useState([
    /*  {
       type:'present',
       title: 'Present',
       leave_type: "Present",
       duration:'9:00 hrs',
       allDay: true,
       start: new Date(2025, 0, 22),
       end: new Date(2025, 0, 22),
     },
    
     {
       type:'absent',
       title: 'Absent',
       leave_type: "Compensation leave",
       duration:'Sick Leave',
       allDay: true,
       start: new Date(2025, 0, 25, 10, 0),
       end: new Date(2025, 0, 25, 12, 0),
     }, */
  ]);
  const [showDateModelView, setShowDateModelView] = useState(false);
  const CustomEvent = ({ event }) => {
    let backgroundColor = '#EBE0FF';
    let borderColor = '3px solid #6929E2';
    if (event.status === "Open") {
      backgroundColor = "#EBE0FF";
      borderColor = '3px solid #6929E2';
    } else if (event.status === "In Progress" || event.status === "Hold") {
      backgroundColor = "#FFF6E9";
      borderColor = '3px solid #FFBA57';
    } else if (event.status === "Closed" || event.status === "Completed") {
      backgroundColor = "#CDFFE2";
      borderColor = '3px solid #17B65B';
    }
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          backgroundColor: backgroundColor,
          padding: "2px 6px",
          borderLeft: borderColor,
          borderRadius: "5px",
          gap: "4px", // space between icon and text
        }}
      >
        {/* Use either FaFlag or FlagICon, not both */}
        {event.priority === "High" && (<FaFlag color="red" size={12} style={{ minWidth: 12, minHeight: 12 }} />)}

        {/* OR if using SVG FlagICon */}
        {/* <FlagICon fill="red" width={16} height={16} style={{ minWidth: 16, minHeight: 16 }} /> */}

        <div
          style={{
            fontSize: "11px",
            fontWeight: "500",
            color: "#212129",
          }}
        >
          {event.title}
        </div>
      </div>


    );
  };
  const eventStyleGetter = (event) => {
    let backgroundColor = '#EBE0FF';
    if (event.status === "Open") {
      backgroundColor = "#EBE0FF";
    } else if (event.status === "In Progress" || event.status === "Hold") {
      backgroundColor = "#FFF6E9";
    } else if (event.status === "Closed" || event.status === "Completed") {
      backgroundColor = "#CDFFE2";
    }
    return {
      style: {
        backgroundColor,
        color: 'white',
        borderRadius: '5px',

        paddingRight: '1px',
        border: 'none',
      },
    };
  };
  const dayPropGetter = (date) => {
    /* const hasEvent = tableData.some(
      (event) =>
        date.toDateString() === new Date(event.start).toDateString() || // Check if date matches event start
        date.toDateString() === new Date(event.end).toDateString() // Check if date matches event end
    );
  
    return {
      style: {
        backgroundColor: hasEvent ? '#87ceeb' : '', // Highlight color for event dates
        borderRadius: '5px',
      },
    }; */
    const day = date.getDay(); // Get day index (0 = Sunday, 6 = Saturday)

    if (day === 0) {
      return { style: { backgroundColor: "#F7F8F9" } }; // Sunday (Red)
    } else {
      return { style: { backgroundColor: "#FFFFFF" } };
    }

    return {};
  };
  const apiUrl = process.env.REACT_APP_API_URL;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedTab, setSelectedTab] = useState("Monthly");
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedOnDay, setSelectedOnDay] = useState(null);
  const [attendanceCount, setAttendanceCount] = useState({});
  const [weekDays, setWeekDays] = useState([]);

  const [weeklyEvents, setWeeklyEvents] = useState([]);
  useEffect(() => {
    setSelectedDate(new Date());
  }, []);
  useEffect(() => {
    console.log(selectedDate);
    if (selectedDate != null) {
      if (selectedTab === 'Weekly') {
        onChangeDateRange({ startDate: startOfWeek(selectedDate), endDate: endOfWeek(selectedDate), });
      }
      if (selectedTab === 'Monthly') {
        onChangeDateRange({ startDate: startOfMonth(selectedDate), endDate: endOfMonth(selectedDate), })
      }
    }
  }, [selectedDate]);

  function formatDateCommon(inputDate, formatType) {
    console.log('current date time.....', inputDate);
    try {
      if (inputDate !== undefined) {
        return moment(inputDate).format(formatType)
      } else {
        return "";
      }
    } catch (err) {
      console.error("Error fetching options:", err);

    } finally {

    }
  }

  function getWeekDays() {
    /*  const selectedWeekDays = eachDayOfInterval({
       start: startOfWeek(selectedDate), // Start of the week
       end: endOfWeek(selectedDate)      // End of the week
     });
     console.log("Days of the Current Week:");
weekDays.forEach(day => console.log(day));
     setWeekDays(selectedWeekDays); */


  }
  function onMonthSelected() {

  }


  const CustomToolbar = ({ label, onNavigate }) => {
    return (
      <div style={{ width: '100%' }} className='d-flex align-items-center justify-content-between mb-2'>
        <div className='d-flex align-items-center'>
          {/* <button style={{width:'74px', height:'36px', borderRadius:'8px', border:'0.8px solid #E5E5E5', background:'#ffffff'}}  onClick={() => onNavigate("TODAY")}>
                  <div style={{fontSize:'12px', fontWeight:'500', color:'#212129'}}></div> Today
                   </button> */}

          <button className='mx-2' style={{ width: '74px', height: '36px', borderRadius: '8px', color: selectedTab === 'Weekly' ? '#6929E2' : '#212129', background: selectedTab === 'Weekly' ? '#F0E9FF' : '#ffffff', border: selectedTab === 'Weekly' ? '0.8px solid #F0E9FF' : '0.8px solid #E5E5E5' }} onClick={() => { setSelectedTab('Weekly'); setView(Views.WEEK) }}>
            <div style={{ fontSize: '12px', fontWeight: '500', }}></div> Weekly
          </button>

          <button style={{ width: '74px', height: '36px', borderRadius: '8px', background: selectedTab === 'Monthly' ? '#F0E9FF' : '#ffffff', color: selectedTab === 'Monthly' ? '#6929E2' : '#212129', border: selectedTab === 'Monthly' ? '0.8px solid #F0E9FF' : '0.8px solid #E5E5E5' }} onClick={() => { setSelectedTab('Monthly'); setView(Views.MONTH); }}>
            <div style={{ fontSize: '12px', fontWeight: '500', }}></div> Monthly
          </button>
        </div>

        <div className='d-flex align-items-center justify-content-end'>
          <img src={calendarIcon} className="ar3" alt="calendar" />
          <span className='mx-2' style={{ fontSize: '14px', fontWeight: '500', color: '#212129' }}>{label}</span>
          <button style={{ width: '36px', height: '36px', border: '0.8px solid #E5E5E5', borderRadius: '100px', background: '#ffffff' }} onClick={() => {
            onNavigate("PREV");
            if (selectedTab === 'Monthly') {
              setSelectedDate(subMonths(selectedDate, 1))
            }
            if (selectedTab === 'Weekly') {
              setSelectedDate(subWeeks(selectedDate, 1))
            }
          }}>
            <img src={prevIcon} className="ar3" alt="previous" />
          </button>
          <button style={{ marginLeft: '8px', width: '36px', height: '36px', border: '0.8px solid #E5E5E5', borderRadius: '100px', background: '#ffffff' }} onClick={() => {
            onNavigate("NEXT")
            if (selectedTab === 'Monthly') {
              setSelectedDate(addMonths(selectedDate, 1))
            }
            if (selectedTab === 'Weekly') {
              setSelectedDate(addWeeks(selectedDate, 1))
            }
          }}><img src={nextIcon} className="ar3" alt="next" /></button>

        </div>
      </div>
    );
  };
  const messages = {
    showMore: (count) => <div className='d-flex align-items-center justify-content-center' style={{ width: '60px', paddingTop: '1px', paddingBottom: '1px', background: '#6929E2', color: "#FFFFFF", borderRadius: '8px', fontSize: '10px', fontWeight: "600", textAlign: 'center' }}>+{count} Tickets</div>, // Customize the text
  };

  const handleSelectSlot = (slotInfo) => {
    setSelectedOnDay(slotInfo.start);
    setShowDateModelView(true);
    console.log(slotInfo.start)
  };
  const handleNavigate = (newDate, view, action) => {
    if (view === Views.DAY) {
      console.log("Navigation to Day view is blocked.");
      return; // Prevents changing to the Day view
    }
    setView(view);
  };

  return (<Container fluid className="GTWalsheimTrial" style={{ display: 'flex' }}>
    {showDateModelView && <CalendarDateViewModal selectedDate={moment(new Date(selectedOnDay)).format("YYYY-MM-DD")} listingType={listingType} onHide={() => { setShowDateModelView(false) }} />}
    <Row sm={12} style={{ width: '100vw', overflow: 'auto', scrollbarWidth: "none", msOverflowStyle: "none", justifyContent: 'center', }}>
      <Col sm={12} style={{ padding: '12px', justifyContent: 'center', }}>
        <div style={{ borderRadius: '16px', padding: '8px', background: '#FFFFFF' }}>


          <Calendar className="GTWalsheimTrial"
            localizer={localizer}
            selectable
            onSelectSlot={handleSelectSlot}
            events={tableData}
            startAccessor="start"
            endAccessor="end"
            date={selectedDate}
            style={{ flexGrow: 1, minHeight: '500px', height: 'calc(100vh - 190px)', margin: '8px', }}
            view={view} // Controlled view state
            onNavigate={handleNavigate}
            onView={(newView) => setView(newView)} // Update view state
            components={{
              /* toolbar: () => null, */
              toolbar: CustomToolbar,
              event: CustomEvent,
              /*  month: {
                 messages,
               }, */
              timeGutterHeader: () => null, // Hide time header
              timeGutter: () => null, // Hide time
            }}
            eventPropGetter={eventStyleGetter}
            dayPropGetter={dayPropGetter}
            messages={messages}
            step={60} // Controls the time slot steps, but not needed when time grid is hidden

            min={null} // Disable minimum time
            max={null} // Disable maximum time
            popup={false} // Disables "Show More" popup
            onShowMore={(events, date,) => {

              console.log("Show More clicked", events, date);
              setSelectedOnDay(date);
              setShowDateModelView(true);
              return null; // Prevents default "Show More" action
            }}
            onSelectEvent={(event, e) => {
              e.preventDefault(); // Prevents event click action
              console.log("Event Click Disabled", event);
              setSelectedOnDay(moment(event.event_date, "DD-MM-YYYY").toDate());
              setShowDateModelView(true);
            }}
          />
        </div>

      </Col>
    </Row>
  </Container>


  );
};

export default TicketCalendar;
